import { Box, TableCell, TableRow, Tooltip, Typography } from "@mui/material"
import { ResolutionStatusChip } from "./resolution-status-chip"
import { navigate } from "lib/routes/navigate"
import { uniqueId } from "library/database/split-id.mjs"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/if"
import { Else } from "lib/@components/else"
import { CriticalityIcon } from "./criticality-icon"
import { ChangeTypeSummaryIcons } from "./change-type-summary-icons"
import { getLegislationResolutionPath } from "./legislation-resolution-route-paths"

export function ResolutionListRow({ item }) {
    const changes = item.proposedChanges ?? []
    const decided = changes.filter((c) => c.decision !== null).length
    const hasChanges = item.status === "complete" || item.status === "applied"
    const flagged = !!item.flaggedForReview

    return (
        <TableRow hover sx={{ cursor: "pointer" }} onClick={navigateToDetail}>
            <TableCell sx={{ width: 40, pr: 0 }}>
                <Tooltip title={flagged ? "Has changes flagged for review" : ""}>
                    <Box
                        sx={{ width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        <If truthy={flagged}>
                            <Iconify icon="eva:flag-fill" sx={{ color: "warning.main" }} />
                        </If>
                    </Box>
                </Tooltip>
            </TableCell>
            <TableCell>
                <Typography variant="body2" fontWeight="bold">
                    {item.code}
                </Typography>
            </TableCell>
            <TableCell>{item.title}</TableCell>
            <TableCell>
                <ResolutionStatusChip status={item.status} />
            </TableCell>
            <TableCell>
                <ChangeTypeSummaryIcons changes={changes} />
            </TableCell>
            <TableCell>
                <CriticalityIcon criticality={item.criticality} />
            </TableCell>
            <TableCell>
                <If truthy={hasChanges}>
                    {changes.length}
                    <Else>—</Else>
                </If>
            </TableCell>
            <TableCell>
                <If truthy={hasChanges}>
                    {decided} / {changes.length}
                    <Else>—</Else>
                </If>
            </TableCell>
        </TableRow>
    )

    function navigateToDetail() {
        navigate(getLegislationResolutionPath(uniqueId(item._id)))
    }
}
